module.exports = __webpack_public_path__ + "img/AramHasan.7b22b0cf.jpg";